// extracted by mini-css-extract-plugin
module.exports = {"page":"zQ-z","cartModal":"AQ-z","checkout":"BQ-z","placeholder":"CQ-z","account":"DQ-z"};